// extracted by mini-css-extract-plugin
module.exports = {"fields":"SmrOlR","time":"OhDgsC","mobile":"l89Wf2"};